
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.684 1.355c-1.833 1.833-4.83 1.819-6.68-.031","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M16.742 8.012c-1.85-1.85-1.863-4.848-.03-6.68","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M14.678 3.358L10 8","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M1.32 16.649c1.832-1.833 4.83-1.819 6.68.03","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M1.258 9.996c1.85 1.85 1.863 4.848.03 6.68","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M3.332 14.64L8 10.008","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}})])
          )
        }
      }
    